import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const CACHE = { value: null, loading: null };

/** Turn an identity (often an email) into a person's display name. */
export function nameOf(value, dir) {
  if (!value) return "";
  const v = String(value);
  if (!v.includes("@")) return v;
  const hit = (dir || []).find(
    (u) => (u.email || "").toLowerCase() === v.toLowerCase(),
  );
  return hit?.name || v;
}

/** Loads the staff directory once (cached) and returns a nameOf() resolver. */
export function useDirectory() {
  const [dir, setDir] = useState(CACHE.value || []);
  useEffect(() => {
    if (CACHE.value) {
      setDir(CACHE.value);
      return undefined;
    }
    if (!CACHE.loading) {
      CACHE.loading = api
        .get("/crew-list")
        .then(({ data }) => {
          CACHE.value = data || [];
          return CACHE.value;
        })
        .catch(() => {
          CACHE.value = [];
          return [];
        });
    }
    let alive = true;
    CACHE.loading.then((d) => {
      if (alive) setDir(d);
    });
    return () => {
      alive = false;
    };
  }, []);
  return { dir, nameOf: (v) => nameOf(v, dir) };
}
